module.exports = __webpack_public_path__ + "static/media/BNW_Alphabet_L.dd495665.jpg";